import {addChild,propertiesToDefinition} from './../util'
import {embedpano} from './krpano'
import {Signal} from 'signals'
import xhook from 'xhook'
import krpanoXML from '../config/krpano.xml'
import {ENV_DEVELOPMENT,ENV_FILESYSTEM,XML} from '../config'
import {composePrototype} from '../util/object'

const {history} = window
const pushState = ::history.pushState

const jsmethods = ['set','get','call','spheretoscreen','screentosphere']
const actions = ['loadpano','loadscene','loadpanoscene','loadxml','openurl']

const classNameLoaderLoading = 'loader--loading'

const xmlEvents = {
  onxmlcomplete: ''
  ,onloadcomplete: 'get(xml.scene)'
  ,onviewchange: 'get(view.hlookat),get(view.vlookat),get(view.fov)'
  ,onkeydown: ''
  ,onmousedown: ''
  ,enterframe: ''
  ,onxmlerror: ''
  ,onloaderror: ''
}

const events = ['onenterfullscreen','onexitfullscreen','onxmlcomplete','onpreviewcomplete','onloadcomplete','onnewpano','onremovepano','onnewscene','onxmlerror','onloaderror','onkeydown','onkeyup','onclick','onsingleclick','ondoubleclick','onmousedown','onmouseup','onmousewheel','oncontextmenu','onidle','onviewchange','onviewchanged','onresize','onautorotatestart','onautorotatestop','onautorotateoneround','onautorotatechange']
events.push(
    'onstart'
    ,'onready'
    ,'onerror'
    ,'onover'
    ,'onout'
)

const panoProto = {
  /**
   * Initialise panorama with a name and an xml uri
   * @param {string} name
   * @param {string} xmluri
   * @param {string} startId
   * @returns {panoProto}
   * @private
   */
  _init(name,xmluri,startId){
    this.name = name
    this._initElement(name)
    this._initSignals()
    this._initXMLHook(name,xmluri,startId)
    this._initEmbedpano(name,xmluri)
    this.loadPanorama(startId) // xml onstart fails
    console.log('\t',this) // todo: remove log
    return this
  }
  /**
   * Initialise root element
   * @param {string} name
   */
  ,_initElement(name){
    const {body} = document
    this.element = addChild(body,'div',{
        id: name
        ,'class': 'pano'
    })
  }
  /**
   * Initialise signal equivalents for each event
   */
  ,_initSignals(){
    events.forEach(event=>this.signal[event.substr(2)] = new Signal())
  }
  /**
   * Add XMLHTTPRequest proxy/hook to update/change the XML before parsing
   * @param {string} name
   * @param {string} xmluri
   * @param {string} startId
   */
  ,_initXMLHook(name,xmluri,startId){
    xhook.before((request,callback)=>{
      // if (request.url===xmluri) {
        const XMLString = this._getMergedXMLString(name,startId)
        ENV_DEVELOPMENT && console.log('pano::_initXMLHook',{request,XMLString}) // todo: remove log
        callback({
          status: 200
          ,statusText: 'OK'
          ,text: XMLString
          ,data: XMLString
          ,finalUrl: request.url
        })
      // }
    })
  }
  /**
   * Embed Krpano
   * @param {string} name
   * @param {string} xmluri
   */
  ,_initEmbedpano(name,xmluri){
    const onready = ::this.onready
    const onerror = ::this.onerror
    console.log('_initEmbedpano',name,xmluri) // todo: remove log
    embedpano({
      xml: xmluri
      ,target: name
      // ,html5: 'only'
      ,html5: 'prefer css3d' // CSS3 is the only way hotspots are HTML elements
      ,onready
      ,onerror
      ,localfallback: 'none'
    })
  }
  /**
   * Find hotspots, add classname and reset style.
   * Only works with CCS3 mode
   * @param {object[]} kobjects
   */
  ,_initHotspots(kobjects){
    kobjects
        .filter(kobject=>kobject._type==='hotspot')
        .forEach(kobject=>{
          const {name,sprite} = kobject
          sprite.style.removeProperty('background-image')
          sprite.classList.add('hotspot')
          sprite.classList.add(`hotspot--${name}`)
        })
  }
  /**
   * Find loading plugin, add classname and reset style.
   * Only works with CCS3 mode
   * @param {kobject[]} kobjects
   */
  ,_initLoader(kobjects){
    const kobject = this._loader = kobjects.find(kobject=>kobject._type==='plugin'&&kobject.name==='loader')
    if (kobject){
      const {sprite} = kobject
      sprite.removeAttribute('style')
      sprite.classList.add('loader')
    }
  }
  /**
   * Event handler for when panorama has initialised
   * @param {HTMLElement} instance
   */
  ,onready(instance){
    this.instance = instance
  }
  /**
   * Event handler for when panorama loaded xml
   * @param {string} startSceneId
   */
  ,onstart(startSceneId){
    this.loadscene(startSceneId)
  }
  /**
   * The event should really be called onloadstart
   */
  ,onxmlcomplete(){
    this._toggleLoader(true)
  }
  /**
   * Event handler for when a scene has loaded
   * @param {string} sceneName
   */
  ,onloadcomplete(sceneName){ // scene load end
    this._scene = this.get(`scene[${sceneName}]`)
    this._view = this.get('view')
    this.call('fade_in_hotspots()')
    //
    const kobjects = Array.from(document.querySelectorAll('div')).filter(div=>div.hasOwnProperty('kobject')).map(div=>div.kobject)
    this._initHotspots(kobjects)
    this._initLoader(kobjects)
    //
    if (!ENV_FILESYSTEM){
      const pathname = `${sceneName}`
      location.hash!==pathname&&pushState(sceneName,null,"#"+pathname)
    }
    //
    this._toggleLoader(false)
  }
  /**
   * Event handler for keydown
   */
  ,onkeydown(){
    // this.set('autorotate.enabled',false)
  }
  /**
   * Event handler for mousedown
   */
  ,onmousedown(){
    // this.set('autorotate.enabled',false)
  }
  /**
   * Call the custom loadPanorama action
   * @param {string} sceneId
   */
  ,loadPanorama(sceneId){
    this.call(`loadPanorama(${sceneId})`)
  }
  /**
   * @returns {string}
   */
  ,toString(){
      return `[object pano ${this.name}]`
  }
  /**
   * Toggle the loader sprite
   * @param {boolean} show
   * @private
   */
  ,_toggleLoader(show){
    this._loader?.sprite.classList.toggle(classNameLoaderLoading,show)
  }
  ,_getMergedXMLString(name,startId){
    const parser = new DOMParser()
    //
    const baseDoc = parser.parseFromString(krpanoXML,'text/xml')
    const baseRoot = baseDoc.documentElement
    //
    const xmlDoc = parser.parseFromString(XML,'text/xml')
    const root = xmlDoc.documentElement
    //
    // root attributes
    Array.from(baseRoot.attributes).forEach(attr => {
      const {name,value} = attr
      !root.hasAttribute(name) && root.setAttribute(name,value)
    })
    // extend children
    Array.from(baseRoot.children).forEach(child => {
      child.nodeName!=='scene' && root.appendChild(child)
    })
    // root>scene>view attrs
    const baseView = baseDoc.querySelector('scene>view')
    const baseViewAttrs = Array.from(baseView.attributes)
    Array.from(xmlDoc.querySelectorAll('scene>view')).forEach(view => {
      baseViewAttrs.forEach(attr => {
        const {name,value} = attr
        !view.hasAttribute(name) && view.setAttribute(name,value)
      })
    })
    //
    const krpanoNode = xmlDoc.querySelector('krpano')
    // add start (stopped working since xhook.before, now direct call in constructor)
    // krpanoNode.setAttribute('onstart',`js(${name}.onstart('${startId}'))`)
    // popstate
    window.addEventListener('hashchange',() => {
      this.loadPanorama(startId)
    })
    // add events
    const eventsNode = xmlDoc.createElement('events')
    Object.entries(xmlEvents).forEach(([eventName,params]) => {
      eventsNode.setAttribute(eventName,`js(${name}.${eventName}(${params}));`)
    })
    krpanoNode.appendChild(eventsNode)
    // extend hotspots
    Array.from(xmlDoc.querySelectorAll('hotspot')).forEach(hotspotNode => {
      const hotspotName = hotspotNode.getAttribute('name')
      const ath = hotspotNode.getAttribute('ath')
      const atv = hotspotNode.getAttribute('atv')
      hotspotNode.setAttribute('onclick',`transition(${hotspotName}, ${ath}, ${atv}, 0, ${hotspotName}, 0, 0, 0)`)
      hotspotNode.setAttribute('onover',`js(${name}.onover(${hotspotName}))`)
      hotspotNode.setAttribute('onout',`js(${name}.onout(${hotspotName}))`)
      hotspotNode.setAttribute('style','hotspot')
    })
    // serialise back to string
    return new XMLSerializer().serializeToString(xmlDoc.documentElement)
  }
}

// proxy public methods to prototype: https://krpano.com/docu/js/
jsmethods.forEach(methodName=>{
  panoProto[methodName] = function(...args){
    ENV_DEVELOPMENT&&console.log(`pano::${methodName}`,...Array.from(arguments))
    return this.instance && this.instance[methodName](...args)
  }
})

// map actions https://krpano.com/docu/actions/#actionsreference
actions.forEach(methodName=>{
  panoProto[methodName] = function(...args){
    ENV_DEVELOPMENT&&console.log(`pano::${methodName}`,...Array.from(arguments))
    return this.call(`${methodName}(${JSON.stringify(args).replace(/^\[|]$/g,'')});`)
  }
})

// map events https://krpano.com/docu/xml/#events
events.forEach(eventName=>{
  const exist = panoProto.hasOwnProperty(eventName)
  const existingMethod = exist && panoProto[eventName]
  panoProto[eventName] = function(...args){
    ENV_DEVELOPMENT&&!['onviewchange'].includes(eventName)&&console.log(`pano::${eventName}`,...Array.from(arguments))
    existingMethod&&existingMethod.call(this,...args)
    this.signal[eventName.substr(2)].dispatch(...args)
  }
})

/**
 * Factory method for creating a pano instance
 * @param {string} name
 * @param {string} xmluri
 * @param {string} startId
 * @param {object} instProto
 * @param {object} instProps
 * @returns {object}
 */
export function createInstance(name,xmluri,startId,instProto,instProps){
  const compositeProto = Object.seal(composePrototype(panoProto,instProto))
  const compositeProps = propertiesToDefinition(Object.assign({},{
      element: null
      ,instance: null
      ,name: null
      ,_scene: null
      ,_view: null
      ,_loader: null
      ,signal: {}
  },instProps))
  const {hash} = location;
  return window[name] = Object.seal(Object.create(compositeProto,compositeProps))
      ._init(name,xmluri,hash.length>0?hash.substring(1):startId)
}

// Object.entries(temp1).sort(([key1],[key2])=>key1>key2?1:-1).map(([key,value])=>` * @property {${typeof value}} ${key}`).filter(line=>!line.includes('{function}')).join('\n')

/**
 * @typedef {object} kobject
 * @property {object} DATA
 * @property {object} GL
 * @property {object} MX
 * @property {number} accuracy
 * @property {object} align
 * @property {number} alpha
 * @property {object} altonloaded
 * @property {boolean} autoalpha
 * @property {boolean} capture
 * @property {boolean} children
 * @property {object} crop
 * @property {object} edge
 * @property {boolean} enabled
 * @property {boolean} forceresize
 * @property {boolean} handcursor
 * @property {object} height
 * @property {boolean} hovering
 * @property {number} imageheight
 * @property {number} imagewidth
 * @property {number} index
 * @property {boolean} ishotspot
 * @property {object} jsplugin
 * @property {boolean} keep
 * @property {boolean} loaded
 * @property {object} loadedurl
 * @property {object} loader
 * @property {boolean} loading
 * @property {object} loadingurl
 * @property {boolean} maskchildren
 * @property {number} maxheight
 * @property {number} maxwidth
 * @property {number} minheight
 * @property {number} minwidth
 * @property {string} name
 * @property {object} onclick
 * @property {object} ondown
 * @property {object} ondowncrop
 * @property {object} onhover
 * @property {object} onloaded
 * @property {object} onout
 * @property {object} onover
 * @property {object} onovercrop
 * @property {object} onup
 * @property {object} ox
 * @property {object} oy
 * @property {object} parent
 * @property {number} pixelheight
 * @property {number} pixelwidth
 * @property {number} pixelx
 * @property {number} pixely
 * @property {boolean} preload
 * @property {boolean} pressed
 * @property {number} rotate
 * @property {boolean} safearea
 * @property {number} scale
 * @property {boolean} scalechildren
 * @property {object} sprite
 * @property {object} style
 * @property {string} type
 * @property {object} url
 * @property {boolean} visible
 * @property {object} width
 * @property {object} x
 * @property {object} y
 * @property {object} zorder
 * @property {number} _aa
 * @property {object} _childs
 * @property {number} _deepscale
 * @property {boolean} _dyn
 * @property {number} _eP
 * @property {number} _eT
 * @property {number} _finalxscale
 * @property {number} _finalyscale
 * @property {number} _haschanged_flags
 * @property {number} _hszscale
 * @property {boolean} _ispreload
 * @property {boolean} _pCD
 * @property {object} _parent
 * @property {number} _pxh
 * @property {number} _pxw
 * @property {boolean} _ready
 * @property {number} _renderer_flags
 * @property {string} _type
 * @property {boolean} _use_css_scale
 * @property {number} _zdeep
 */


// WEBPACK FOOTER //
// ./src/js/pano/index.js